import { FaExternalLinkAlt } from 'react-icons/fa';

const Resume = () => (
  <div className="resume">
    <a href="https://docs.google.com/document/d/1bqCbByQQEliLvMf5lLbrnzc0k62yo8tGYxs6KaKqBjM/edit?usp=sharing" target="_blank" rel="noreferrer">
      Get my resume
      <FaExternalLinkAlt />
    </a>
  </div>
);
export default Resume;
